export enum SettingsState {
  None = 0,
  GetSettingsLoading = 1 << 0,
  UpdatingLoading = 1 << 1,
  Initialized = 1 << 2,
}
